import "./index.scss";
import React, { useEffect, lazy, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import All from "./All";
import PrivateRoute from "./components/HOC/PrivateRoute";
import { isUserLoggedIn } from "./actions/Auth_action";
import { Change_LangugeHeader } from "./actions/Helper_action";
import "./App.css";
import Agent_Dashboard from "./Dashboards/Agent_Dashboard";
import Login from "./containers/Form/login";
import {
  EditRentDetail,
  EditRentUpdate,
  EditRequired,
  EditRequiredRent,
  EditSellDetail,
  EditUpdateProperty,
  ListRentRequired,
  ListRequiredProperty,
  PrintRentList,
  PrintSellList,
  RentListProperty,
  PrintListRequiredRent,
  PrintListRequired,
  AddProperty,
  AddRequiredProperty,
  SellListProperty,
} from "./containers_Agent/Propertys_Agent";
import {
  Asaysh_Form,
  ListMasrufat,
  ListParadan,
  ListTakeMoney,
  ListWriteForm,
  Paradan,
  PrintAsaysh,
  PrintViewScurety,
  PrintWriteForm,
  Print_ViewParadan,
  Print_ViewTakemoney,
  ScurityList,
  TakeMoney,
  PrintMasrufat,
  Kryar_Form,
  ListKryar,
  PrintKryar,
  PrintViewKryar,
} from "./containers_Agent/ListBills_Agent";
import {
  EditContractRentList,
  EditRentInvoice,
  ListRentContract,
  Main_Form,
  RentPrint,
  SecondaryForm,
  EditContractSell,
  EditInvoce,
  ListSellContract,
  SellMain_Form,
  SellSecondaryForm,
  SellPrint,
  ListRentContract_Failed,
  ListSellContract_Failed,
} from "./containers_Agent/Contracts_Agent";
import {
  TenantView_Contract,
  Tenant_ViewParadan,
  Tenant_ViewTakeMoney,
  PrintTenants,
} from "./containers_Agent/Tenants_Agent";
import {
  PrintApartmentShuqa,
  ProjectListing,
  ViewProject,
} from "./containers_Agent/project_agent";
import {
  LisCustomerCall,
  ListCustomerVisit,
  ListCustomerService,
} from "./containers/Customers";
import {
  PunshedFormList,
  SalaryForm,
  PersentageForm,
  ReAccounting,
  PrintSalary,
  PrintPersentage,
  PrintPunshed,
  PrintSalaryForm,
  ListMasrufBranch,
  RePrintMasrufat,
} from "./containers/Acounting";
import {
  AllRaportAgentRatio,
  BoxRaport,
  TajRentReport,
  TajSellReport,
  PrintBoxReport,
  AgentPerformance,
} from "./containers/AllReports";
import { ListType_Expenses } from "./containers/Expenses";
import { PropertyReport, RequiredReport } from "./containers_Agent/AgentReport";
const LazyTodo = lazy(() => import("./containers_Agent/TodoList/TodoApp"));
const LazyCustomer = lazy(() =>
  import("./containers/Customers/ListCustomerDetail")
);
const LazyProfile = lazy(() => import("./containers/settings/ProfileAgent"));
const LazyUpdateProfile = lazy(() =>
  import("./components/common/header_components/ProfileUser/UserProfileAgent")
);
const LazyTenantList = lazy(() =>
  import("./containers_Agent/Tenants_Agent/TenantList")
);

const TodoApp = () => (
  <Suspense fallback="loading...">
    <LazyTodo />
  </Suspense>
);
const ListCustomersDetail = () => (
  <Suspense fallback="loading...">
    <LazyCustomer />
  </Suspense>
);
const UserProfileAgent = () => (
  <Suspense fallback="loading...">
    <LazyUpdateProfile />
  </Suspense>
);
const ProfileAgent = () => (
  <Suspense fallback="loading...">
    <LazyProfile />
  </Suspense>
);
const TenantList = () => (
  <Suspense fallback="loading...">
    <LazyTenantList />
  </Suspense>
);
function App_Agent() {
  const isAuth = useSelector((state) => state.AuthReducer.isAuth);
  const key_lang = window.localStorage.getItem("key_lang");
  const token = window.localStorage.getItem("token_GPC_admin");
  const dispatch = useDispatch();
  useEffect(() => {
    if (token) {
      dispatch(isUserLoggedIn());
    }
    window.document.body.classList.add("rtl");
    if (key_lang === "krd") {
      window.document.body.classList.add("rtl");
      dispatch(Change_LangugeHeader("Kurdish"));
    } else if (key_lang === "eng") {
      window.document.body.classList.remove("rtl");
      dispatch(Change_LangugeHeader("English"));
    } else if (key_lang === "arb") {
      window.document.body.classList.add("rtl");
      dispatch(Change_LangugeHeader("Arabic"));
    }
  }, [isAuth]);
  return (
    <>
      <Router>
        {/* {window.navigator.onLine !== true ? (
          <NoEnternet ok />
        ) : ( */}
        <div className="App">
          {!token && <Redirect from="*" to="/" />}
          <Switch>
            <Route exact path="/" component={Login} />
            <Route
              path={`/print_Sell_Property/:status/:search`}
              component={PrintSellList}
            />
            <Route
              path={`/print_Rent_Property/:status/:search`}
              component={PrintRentList}
            />
            <Route
              path={`/print_Rent_required`}
              component={PrintListRequiredRent}
            />
            <Route
              path={`/print_sell_required`}
              component={PrintListRequired}
            />
            <Route path={`/print_Sell_View/:id/:index`} component={SellPrint} />
            <Route path={`/print_Rent_View/:id/:index`} component={RentPrint} />
            <Route
              path={`/View_takemoney_print/:id/:index`}
              component={Print_ViewTakemoney}
            />
            <Route
              path={`/View_paradan_print/:id/:index`}
              component={Print_ViewParadan}
            />
            <Route path={`/print_view_asyash`} component={PrintViewScurety} />
            <Route path={`/print_Asaysh`} component={PrintAsaysh} />
            <Route
              path={`/Print_Writer_Form/:index`}
              component={PrintWriteForm}
            />
            <Route path={`/print_exp`} component={PrintMasrufat} />
            <Route path={`/print_tenant_list`} component={PrintTenants} />
            <Route path={`/print_customer_anket`} component={PrintKryar} />
            <Route path={`/print_customer_view`} component={PrintViewKryar} />
            <Route
              path={`/print_Apartment_Project/:status`}
              component={PrintApartmentShuqa}
            />
            <Route
              exact
              path="/Print_Salary/:from/:to"
              component={PrintSalary}
            />
            <Route
              path={`/print_salary_form/:id`}
              component={PrintSalaryForm}
            />
            <Route path={`/print_punshed_form/:id`} component={PrintPunshed} />
            <Route path={`/print_ratio_form/:id`} component={PrintPersentage} />
            <Route
              exact
              path="/PrintAllBoxReport/:from/:to"
              component={PrintBoxReport}
            />
            <Route
              exact
              path="/Print_Masrufat_Branch/:from/:to/:type"
              component={RePrintMasrufat}
            />
            <All>
              <PrivateRoute
                exact
                path="/dashboard"
                component={Agent_Dashboard}
              />
              <PrivateRoute path={`/Project_List`} component={ProjectListing} />
              <PrivateRoute
                path={`/View_Project_Path/:id`}
                component={ViewProject}
              />
              <PrivateRoute
                exact
                path={`/UserProfile_Agent`}
                component={UserProfileAgent}
              />
              <PrivateRoute
                exact
                path={`/settings/profile_Agent`}
                component={ProfileAgent}
              />
              <PrivateRoute
                path={`/Secondary_Form`}
                component={SecondaryForm}
              />
              <PrivateRoute path={`/Main_Form`} component={Main_Form} />
              <PrivateRoute
                path={`/Secondary_Sell_Form`}
                component={SellSecondaryForm}
              />
              <PrivateRoute
                path={`/Main_Sell_Form`}
                component={SellMain_Form}
              />
              <PrivateRoute path={`/pswlay_Asaysh`} component={Asaysh_Form} />
              <PrivateRoute path={`/take_money`} component={TakeMoney} />
              <PrivateRoute path={`/pswlay_paradan`} component={Paradan} />
              <PrivateRoute path={`/Customer_Anket`} component={Kryar_Form} />
              <PrivateRoute
                path={`/list_Anket_customert`}
                component={ListKryar}
              />
              {/* ------------this is cards inside dashboard -------------*/}
              <PrivateRoute
                path={`/list_Rent_Property`}
                component={RentListProperty}
              />
              <PrivateRoute
                exact
                path={`/list_Sell_Property`}
                component={SellListProperty}
              />
              <PrivateRoute
                path={`/property/add-required-property`}
                component={AddRequiredProperty}
              />
              <PrivateRoute
                path={`/required-products/rent-list`}
                component={ListRentRequired}
              />
              <PrivateRoute
                path={`/required-products/sell-list`}
                component={ListRequiredProperty}
              />
              <PrivateRoute
                path={`/property/add-property`}
                component={AddProperty}
              />
              <PrivateRoute
                path={`/List_Sell_Invoices`}
                component={ListSellContract}
              />
              <PrivateRoute
                path={`/List_Sell_Invoices_fast`}
                component={ListSellContract_Failed}
              />
              <PrivateRoute
                path={`/List_Rent_Invoices`}
                component={ListRentContract}
              />
              <PrivateRoute
                path={`/List_Rent_Invoices_fast`}
                component={ListRentContract_Failed}
              />
              <PrivateRoute
                path={`/take_money_list`}
                component={ListTakeMoney}
              />
              <PrivateRoute path={`/List_Paradan`} component={ListParadan} />
              <PrivateRoute path={`/List_Scurety`} component={ScurityList} />
              <PrivateRoute
                path={`/list_Sell_Property/view_detail_sell/:id`}
                component={EditSellDetail}
              />
              <PrivateRoute
                path={`/view_detail_rent/:id`}
                component={EditRentDetail}
              />
              <PrivateRoute
                path={`/view_detail_required_sell/:id`}
                component={EditRequired}
              />
              <PrivateRoute
                path={`/view_detail_required_rent/:id`}
                component={EditRequiredRent}
              />
              <PrivateRoute
                path={`/view_contract_sell/:id/:index`}
                component={EditContractSell}
              />
              <PrivateRoute
                path={`/view_contract_rent/:id/:index`}
                component={EditContractRentList}
              />
              <PrivateRoute path={`/Tenant_Lists`} component={TenantList} />
              <PrivateRoute
                path={`/Tenant_View_All_TakeMoney/:id`}
                component={Tenant_ViewTakeMoney}
              />
              <PrivateRoute
                path={`/Tenant_View_All_Paradan/:id`}
                component={Tenant_ViewParadan}
              />
              <PrivateRoute
                path={`/Tenant_View_All_Contract/:id`}
                component={TenantView_Contract}
              />
              <PrivateRoute
                path={`/update-property-sell/:id`}
                component={EditUpdateProperty}
              />
              <PrivateRoute
                path={`/update-property-rent/:id`}
                component={EditRentUpdate}
              />
              <PrivateRoute
                path={`/List_customers_detail`}
                component={ListCustomersDetail}
              />
              <PrivateRoute
                path={`/List_customers_call`}
                component={LisCustomerCall}
              />
              <PrivateRoute
                path={`/List_customers_visit`}
                component={ListCustomerVisit}
              />
              <PrivateRoute
                path={`/List_customers_service`}
                component={ListCustomerService}
              />
              <PrivateRoute
                path={`/list_of_Masrufat`}
                component={ListMasrufat}
              />
              <PrivateRoute
                path={`/Invoice_Detail/:id`}
                component={EditInvoce}
              />
              <PrivateRoute
                path={`/Invoice_Rent_Detail/:id`}
                component={EditRentInvoice}
              />
              <PrivateRoute path={`/Todo_List`} component={TodoApp} />
              <PrivateRoute path={`/List_Writers`} component={ListWriteForm} />
              <PrivateRoute
                path={`/property_report`}
                component={PropertyReport}
              />
              <PrivateRoute
                path={`/required_report`}
                component={RequiredReport}
              />
              <PrivateRoute path={`/List_Form_Salary`} component={SalaryForm} />
              <PrivateRoute path={`/List_bounes`} component={PunshedFormList} />
              <PrivateRoute
                path={`/List_Form_persentage`}
                component={PersentageForm}
              />
              <PrivateRoute path={`/list_salary`} component={ReAccounting} />
              <PrivateRoute
                path={`/list_BranchMasrufat`}
                component={ListMasrufBranch}
              />
              <PrivateRoute
                path={`/List_type_exp`}
                component={ListType_Expenses}
              />
              {/* report */}
              <PrivateRoute
                path={`/All_Project_Report`}
                component={AllRaportAgentRatio}
              />
              <PrivateRoute
                path={`/Sell_Taj_Report`}
                component={TajSellReport}
              />
              <PrivateRoute
                path={`/Rent_Taj_Report`}
                component={TajRentReport}
              />
              <PrivateRoute path={`/All_Box_Report`} component={BoxRaport} />
              <PrivateRoute
                path={`/agent_performance`}
                component={AgentPerformance}
              />
            </All>
          </Switch>
        </div>
        {/* )} */}
      </Router>
    </>
  );
}

export default App_Agent;
